module.exports = __webpack_public_path__ + "img/win_item17.5f4039f2.png";